import _ from 'lodash';

import PropTypes from 'prop-types';
import classnames from 'classnames';

import React, {PureComponent} from 'react';
import OnClickOutside from 'react-onclickoutside';
import {Scrollbars} from 'react-custom-scrollbars';

import {Spinner, TextField, FormField} from 'components/controls';

import styles from './SectionedSearchDropdown.scss';
import {noop} from 'components/helpers/funcTools';

const compareByOrder = (lhs, rhs) => {
    const lhsOrder = _.get(lhs, 'order', 0);
    const rhsOrder = _.get(rhs, 'order', 0);
    return lhsOrder - rhsOrder;
};

// TODO: refactor this to inverse control to the parent properly.

class SectionedSearchDropdown extends PureComponent {
    static propTypes = {
        className: PropTypes.string,
        label: PropTypes.string,
        placeholder: PropTypes.string,
        emptyLabel: PropTypes.string,
        error: PropTypes.string,
        /**
         const sections = [
            // each object is a section
            {
                name: 'Problem list',
                items: [{name: 'Tetanus', id: 'A33'},],
                // sections with lower order get rendered first and closer to the top
                order: 2,
            },
         ]
         */
        sections: PropTypes.array,
        selectedOption: PropTypes.object,
        selectedSection: PropTypes.object,
        isLoading: PropTypes.bool,
        isDisabled: PropTypes.bool,
        onClear: PropTypes.func,
        onSearch: PropTypes.func.isRequired,
        onSelect: PropTypes.func.isRequired,
    };

    static defaultProps = {
        className: '',
        label: '',
        placeholder: '',
        emptyLabel: loc('no-search-results'),
        error: '',
        search: '',
        sections: [],
        selectedOption: null,
        selectedSection: null,
        onClear: noop,
        isLoading: false,
        isDisabled: false,
    };

    state = {
        isProcessing: false,
        isSearchFieldFocused: false,
    };

    handleFocus = () => {
        this.setState({isSearchFieldFocused: true});
    };

    handleSelect = (section, option) => {
        const {onSelect} = this.props;
        this.setState({isSearchFieldFocused: false});
        onSelect(section, option);
    };

    handleClear = () => {
        const {onClear} = this.props;
        this.handleSelect(null, null);
        onClear();
    };

    // This is used by the OnClickOutside HOC.
    // noinspection JSUnusedGlobalSymbols
    handleClickOutside = () => {
        this.setState({isSearchFieldFocused: false});
    };

    handleSearch = ({target: {value}}) => {
        const {onSearch} = this.props;
        onSearch(value);
    };

    renderEmptySectionBody = () => (
        <div className={styles.emptyItem}>
            {this.props.emptyLabel}
        </div>
    );

    renderSpinner = () => <div className={styles.loader}>
        <Spinner size={10}/>
    </div>;

    renderSearchField = () => {
        const {
            isLoading,
            isDisabled,
            placeholder,
            error,
        } = this.props;
        const {search} = this.state;

        const searchClassname = classnames(
            styles.searchField,
            {
                [styles.searchFieldLoading]: isLoading,
                [styles.error]: Boolean(error),
            });

        return (
            <TextField
            className={searchClassname}
            value={search}
            placeholder={placeholder}
            onChange={this.handleSearch}
            onFocus={this.handleFocus}
            disabled={isDisabled}/>
        );
    };

    renderSelectedOption = () => {
        const {selectedSection, selectedOption, selectedOptionClassname} = this.props;

        const wrapperSelectedOptionStyle = selectedOptionClassname ?
            styles.selectedOptionAbsolutePosition :
            styles.selectedOption;

        return (
            <div className={wrapperSelectedOptionStyle}>
                {selectedOptionClassname ?
                    <div className={selectedOptionClassname}>{selectedSection.getOptionLabel(selectedOption)}</div> :
                    selectedSection.getOptionLabel(selectedOption)
                }
                <div className={styles.clearButton} onClick={this.handleClear} />
            </div>
        );
    };

    renderOption = (section, option) => {
        return (
            <div
                className={styles.item}
                key={section.getOptionKey(option)}
                role='option'
                onClick={this.handleSelect.bind(this, section, option)}>
                <p>{section.getOptionLabel(option)}</p>
            </div>
        )
    };

    renderSectionHeader = section => (
        <div className={styles.sectionHeader}>
            {section.getLabel()}
        </div>
    );

    renderOptions = () => {
        const sections = this.props.sections;

        const renderedSections = sections
            .sort(compareByOrder)
            .map((section) => {
                const renderedOptions = section.options
                    .map((option) => this.renderOption(section, option));
                const hasOptions = renderedOptions && renderedOptions.length;

                return (
                    <div className={styles.section} role='listbox' key={section.getKey()}>
                        {this.renderSectionHeader(section)}
                        {hasOptions ? renderedOptions : this.renderEmptySectionBody()}
                    </div>
                );
        });

        const containerStyles = classnames(styles.resultsContainer, {[styles.nonEmpty]: Boolean(sections.length)});

        return (
            <div className={containerStyles}>
                <Scrollbars autoHeight>
                {renderedSections}
                </Scrollbars>
            </div>
        );
    };

    render() {
        const {selectedOption, selectedSection, isLoading, error, label} = this.props;
        const {isSearchFieldFocused} = this.state;

        const isSelected = selectedOption && selectedSection;
        const mainElement = isSelected ? this.renderSelectedOption() : this.renderSearchField();

        const shouldRenderOptions = isSearchFieldFocused && !isLoading;
        const inputClassname = classnames(styles.container, {[styles.error]: Boolean(error)})

        return (
            <FormField error={error} label={label}>
                <div className={inputClassname}>
                    {mainElement}
                    {isLoading && this.renderSpinner()}
                    {shouldRenderOptions && this.renderOptions()}
                </div>
            </FormField>
        )
    }
}

export default OnClickOutside(SectionedSearchDropdown);



// WEBPACK FOOTER //
// ./src/components/controls/dropdowns/SectionedSearchDropdown/SectionedSearchDropdown.jsx